var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.conversations.noconvnofollower
      ? _c("div", [_vm._v(_vm._s(_vm.$t("dash.div.noconvnofollower")) + " ")])
      : _vm._e(),
    _vm.conversations.notallowed
      ? _c("div", [_vm._v(" " + _vm._s(_vm.$t("dash.div.notallowed")) + " ")])
      : _vm._e(),
    _vm.page.network == "instagram" && _vm.conversations.nofb
      ? _c("div", [_vm._v(_vm._s(_vm.$t("dash.div.nofb")))])
      : _vm._e(),
    _vm.conversations
      ? _c("div", { staticClass: "chats" }, [
          _c("div", { staticClass: "chat-search" }, [
            _c("input", {
              attrs: {
                type: "text",
                placeholder: _vm.$t("dash.placeholder.search"),
                id: "myInput",
              },
              on: { keyup: _vm.Search },
            }),
            _c(
              "div",
              { staticClass: "filter" },
              [
                _c(
                  "vs-dropdown",
                  { attrs: { "vs-trigger-click": true } },
                  [
                    _c("vs-button", {
                      staticClass: "btn-filter",
                      attrs: { type: "filled", icon: "more_horiz" },
                    }),
                    _c(
                      "vs-dropdown-menu",
                      [
                        _c(
                          "vs-dropdown-item",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.filterInbox.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("dash.button.inbox")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _c(
                          "vs-dropdown-item",
                          {
                            staticClass: "delete-comment",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.FilterFollow.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("dash.button.follow")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _c(
                          "vs-dropdown-item",
                          {
                            staticClass: "delete-comment",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.filterUnread.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("dash.button.unread")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _c(
                          "vs-dropdown-item",
                          {
                            staticClass: "delete-comment",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.filterDone.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("dash.button.done")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _c(
                          "vs-dropdown-item",
                          {
                            staticClass: "delete-comment",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.filterSpam.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("dash.button.spam")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "conversation-ul scrollable" }, [
            _c(
              "ul",
              { attrs: { id: "myUl" } },
              _vm._l(_vm.conversations.data, function (conversation, key) {
                return _c("li", { key: key }, [
                  conversation &&
                  conversation.participants.data[0].name &&
                  conversation.id
                    ? _c(
                        "div",
                        {
                          staticClass: "chat",
                          attrs: { id: "chatindex", tabindex: "0" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.showDiscussion(
                                conversation.id,
                                conversation.participants.data[_vm.getInstagram]
                                  .id
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "chat-image" }, [
                            _vm.listUser &&
                            _vm.listUser[key] &&
                            _vm.listUser[key].body &&
                            _vm.listUser[key].body.user &&
                            _vm.listUser[key].body.user.picture
                              ? _c("img", {
                                  staticClass: "chat-image",
                                  attrs: {
                                    src: _vm.listUser[key].body.user.picture
                                      .data.url,
                                  },
                                })
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "chat-content" }, [
                            _c(
                              "div",
                              {
                                staticClass: "chat-content-name",
                                class: {
                                  "new-message": conversation.unread_count > 0,
                                },
                                attrs: { href: "#" },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      conversation.participants.data[0].name
                                    ) +
                                    "\n                      "
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "chat-content-post" }, [
                              _vm.page.network == "facebook"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "chat-content-post-message",
                                      class: {
                                        "new-message": conversation > 0,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.sliceSnippet(
                                              conversation.snippet
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "chat-content-post-date" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.dateFromNow(
                                          conversation.updated_time
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ])
              }),
              0
            ),
            _vm.conversations.paging &&
            _vm.conversations.paging.next &&
            _vm.conversations.data[29]
              ? _c(
                  "div",
                  { staticClass: "pagination-posts next-post" },
                  [
                    _c(
                      "vs-button",
                      {
                        staticClass: "page-btn btn-large",
                        attrs: { "vs-type": "filled" },
                        on: {
                          click: function ($event) {
                            return _vm.paginationConversations("next")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t("dash.moderation.next-conversations")
                            ) +
                            "\n      "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }